import * as React from "react";
import { Code } from "@chakra-ui/react";
import type { ReactNode } from "react";
type InlineCodeProps = {
  children: ReactNode;
};

export function InlineCode({ children }: InlineCodeProps) {
  return (
    <Code
      bgColor="gray.100"
      color="indigo.500"
      _dark={{
        bgColor: "gray.900",
        color: "blue.100",
      }}
      fontSize="calc(1em / 1.125)"
    >
      {children}
    </Code>
  );
}
